module.exports = __webpack_public_path__ + "img/dd-logo-nissan-w.c9779fb4.png";